import React from "react";
import { Layout } from "antd";

const ContentLayout = ({ children, className, style }) => {
  return (
    <Layout className={`screen-width screen-height ${className}`} style={style}>
      {children}
    </Layout>
  );
};

export { ContentLayout };
